var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popconfirm',{attrs:{"ok-text":"Kunjungi Halaman Admin"},on:{"confirm":_vm.confirm},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n    Untuk saat ini silahkan gunakan Admin versi Terbaru.\n  ")]},proxy:true}])},[_vm._v(" "),_c('a-button',{attrs:{"type":"danger","ghost":""}},[_c('span',[_vm._v("Tolak")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }